module.exports = __webpack_public_path__ + "img/erp-logos_0015_sagebc.3974762e.jpg";